import React from 'react';
import { ThumbsDown, Heart, Clock, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';

const VentCard = ({ post, onReaction }) => {
  const { id, content, author, location, tags = [], reactions = {}, timestamp } = post;
  const disgusted = reactions.disgusted || 0;
  const support = reactions.support || 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="bg-slate-800 border border-slate-700 p-6 rounded-xl hover:border-orange-500 transition-all group hover:shadow-lg"
    >
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-2 text-xs text-slate-500">
          <span className="font-medium">{author || '匿名工友'}</span>
          {location && (
            <>
              <span>·</span>
              <div className="flex items-center gap-1">
                <MapPin className="w-3 h-3" />
                <span>{location}</span>
              </div>
            </>
          )}
          <span>·</span>
          <div className="flex items-center gap-1">
            <Clock className="w-3 h-3" />
            <span>{timestamp}</span>
          </div>
        </div>

        <div className="flex gap-2">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onReaction(id, 'disgusted')}
            className="flex items-center gap-1 text-xs bg-red-900 text-red-400 px-3 py-1 rounded-full hover:bg-red-800 transition-all border border-red-500"
          >
            <ThumbsDown className="w-3 h-3" />
            <span>恶心爆了</span>
            <span className="ml-1 font-semibold">{disgusted}</span>
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onReaction(id, 'support')}
            className="flex items-center gap-1 text-xs bg-blue-900 text-blue-400 px-3 py-1 rounded-full hover:bg-blue-800 transition-all border border-blue-500"
          >
            <Heart className="w-3 h-3" />
            <span>拥抱同行人</span>
            <span className="ml-1 font-semibold">{support}</span>
          </motion.button>
        </div>
      </div>

      {/* Content */}
      <div className="mb-4">
        <p className="text-slate-200 leading-relaxed italic text-lg">
          {content}
        </p>
      </div>

      {/* Tags */}
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="text-xs text-slate-400 border border-slate-600 px-2 py-1 rounded italic hover:border-slate-500 hover:text-slate-300 transition-all"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}

      {/* Hot indicator */}
      {disgusted > 50 && (
        <div className="mt-3 flex items-center gap-2">
          <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
          <span className="text-xs text-red-400 font-semibold">🔥 职场重灾区</span>
        </div>
      )}
    </motion.div>
  );
};

export default VentCard;